import React from 'react';
import { 
  FaRobot, 
  FaShieldAlt, 
  FaChartBar, 
  FaBullseye, 
  FaLock, 
  FaGraduationCap 
} from 'react-icons/fa';
import '../styles/About.css';

const About = () => {
  const features = [
    {
      icon: <FaRobot className="feature-icon" />,
      title: 'AI-Powered Analysis',
      description: 'Advanced machine learning algorithms analyze market trends and identify opportunities in real-time.'
    },
    {
      icon: <FaShieldAlt className="feature-icon" />,
      title: 'Security First',
      description: 'Enterprise-grade security measures protect your data and transactions at all times.'
    },
    {
      icon: <FaChartBar className="feature-icon" />,
      title: 'Real-Time Insights',
      description: 'Get instant market analysis and trading signals based on comprehensive data analysis.'
    },
    {
      icon: <FaBullseye className="feature-icon" />,
      title: 'Smart Targeting',
      description: 'Identify promising projects and tokens before they gain mainstream attention.'
    },
    {
      icon: <FaLock className="feature-icon" />,
      title: 'Risk Management',
      description: 'Advanced risk assessment tools help you make informed trading decisions.'
    },
    {
      icon: <FaGraduationCap className="feature-icon" />,
      title: 'Educational Resources',
      description: 'Access comprehensive guides and tutorials to master crypto trading.'
    }
  ];

  return (
    <section className="about" id="about">
      <div className="about-container">
        <div className="about-header">
          <h2 className="about-title">Why Choose The Firm</h2>
          <div className="title-underline"></div>
          <p className="about-subtitle">
            Experience the power of AI-driven crypto trading with our advanced features and tools
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              className="feature-card" 
              key={index}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="feature-icon-wrapper">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="about-cta">
          <a 
            href="https://t.me/TheFirmAIProtocols_bot" 
            target="_blank" 
            rel="noopener noreferrer"
            className="cta-button"
          >
            Start Trading Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default About; 